module.exports = __webpack_public_path__ + "img/filter-intensity-low.05326c38.svg";